import { Injectable } from '@angular/core';

function getWindow(): any {
  return window;
}

@Injectable()
export class WindowService {
  public get nativeWindow(): any {
    return getWindow();
  }

  public open(url: string): void {
    this.nativeWindow.open(url, '_blank');
  }

  public navigate(url: string): void {
    this.nativeWindow.location.href = url;
  }

  public getCurrentLocation(): string {
    return this.nativeWindow.location.href;
  }

  public getOrigin(): string {
    return this.nativeWindow.location.origin;
  }

  public scrollIntoView(
    elementToScroll: { selector: string; byClass?: boolean },
    fallBackElementToScroll?: { selector: string; byClass?: boolean }
  ): void {
    let element: Element;
    element = this.getElementByClassOrId(
      elementToScroll.selector,
      elementToScroll.byClass
    );
    if (!element && fallBackElementToScroll) {
      element = this.getElementByClassOrId(
        fallBackElementToScroll.selector,
        fallBackElementToScroll.byClass
      );
    }
    if (element) {
      element.scrollIntoView();
    }
  }

  public getMenuLocation() {
    return getWindow().localStorage.getItem('menu_location') || '/menu';
  }

  private getElementByClassOrId(
    elementSelector: string,
    byClass: boolean
  ): Element {
    if (byClass) {
      return this.getFirstElementByClass(elementSelector);
    } else {
      return this.getElementById(elementSelector);
    }
  }

  private getElementById(elementSelector: string): Element {
    return document.getElementById(elementSelector);
  }

  private getFirstElementByClass(elementSelector: string): Element {
    return document.getElementsByClassName(elementSelector)[0];
  }
}
